import React, { useContext } from 'react'
import { GlobalContext } from '../context/GlobalState'

const ConnectivityMsg = () => {
  const context = useContext(GlobalContext)

  return (
    <>
    {context.status === 'offline' && (
      <div className="connectivity">
        <span className="fa-stack fa-1x">
          <i className="fas fa-wifi fa-stack-1x"></i>
          <i className="fas fa-slash fa-stack-1x"></i>
        </span>
        <span>Connectivity error. Using cached data.</span>
      </div>
    )}
    </>
  )
}

export default ConnectivityMsg